import { Component, OnInit } from '@angular/core';
import { UnsubscribeService } from "app/unsubscribe-newsletter/unsubscribe.service";
import { NewsletterResource } from "app/models/NewsletterResource";
import { Params, ActivatedRoute } from '@angular/router';
import { MessageService } from "app/message-service.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from 'environments/environment';
import { GdprService } from './gdpr.service';
import { TermsOrGdprResource } from 'app/models/TermsOrGdprResource';
import { UtilsService } from 'app/services/utils.service';

@Component({
  selector: 'vbn-gdpr',
  providers: [GdprService],
  templateUrl: './gdpr.component.html',
  styleUrls: ['./gdpr.component.scss']
})
export class GdprComponent implements OnInit {

  errorMessage: any;
  gdprResource: TermsOrGdprResource
  params: any
  email: any
  languageMail: any
  error: boolean = false;
  language = localStorage.getItem("vbn-language");
  showUnsubMessage: boolean = true;
  showUnsubButton: boolean = false;
  userEmail:string;
  lang = "en";
  title: string;
  description: any;

  constructor(private gdprService: GdprService, private route: ActivatedRoute, private translate: TranslateService,
        private messageService: MessageService, private service:UtilsService) {
    this.gdprResource = new TermsOrGdprResource();
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.params = this.route.params.forEach((params: Params) => {
      this.userEmail = params['userEmail'];
      this.lang = params['lang'];
      console.log("lang = ", this.lang);
      this.getGdprContent();
    });
    
  }

 

  getGdprContent() {
    this.gdprService.getGdpr(`admin/text/termsOrGdpr/get?email=${this.userEmail}&terms=false`).subscribe(
      body => {
        this.gdprResource = body;
        this.title = this.gdprResource["title"+this.lang[0].toUpperCase() + this.lang[1].toLowerCase()]
        this.description = this.gdprResource["description"+this.lang[0].toUpperCase() + this.lang[1].toLowerCase()]
        console.log("------------------", body)
        console.log("-----------------TITLE -", this.title)
        console.log("----------------- DESCRIPTION-", this.description)
       
      },
      error => {
      })
  }

}
